// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GZ30[data-v-44448e16]{position:relative;background-color:#fff}.GZ30[data-v-44448e16],.ibKi[data-v-44448e16]{border-radius:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "GZ30",
	"comp__loading": "ibKi"
};
module.exports = ___CSS_LOADER_EXPORT___;
